import React from 'react';
import PropTypes from 'prop-types';
import ACDefinitionFolder from './ACDefinitionFolder';
import windowSize from '../../common/windowSize';
import { _getStudyGroupedData } from '../../../util/autocodeUtils';

// create usewindow in autocode
const ACDefinitionFoldersList = ({
  definitionList,
  onLeafNodeClicked,
  selectedFolder,
  setselectedFolder,
  canAddNewFolders,
}) => {
  let groupedData = {
    personal: [],
    shared: [],
    global: [],
  };

  if (definitionList && definitionList.data && definitionList.data.length > 0) {
    groupedData = _getStudyGroupedData(definitionList.data);
  }

  const size = windowSize('importDefinitionMain');
  const totalHeight = size.height;
  const totalFolders = 3;
  const folderHeight = 32;
  const threshold = 26 + 12;
  const defaultHeight = 78;
  let personalHeight = defaultHeight;
  let sharedHeight = defaultHeight;
  let globalHeight = defaultHeight;

  if (totalHeight) {
    const maxHeight = totalHeight / totalFolders;
    const maxFoldersToShow = Math.floor((maxHeight - threshold) / folderHeight);
    const { personal, shared } = groupedData;
    if (personal.length > maxFoldersToShow) {
      personalHeight = maxHeight;
    } else {
      personalHeight =
        personal.length > 0
          ? personal.length * folderHeight + threshold
          : defaultHeight;
    }
    if (shared.length > maxFoldersToShow) {
      sharedHeight = maxHeight;
    } else {
      sharedHeight =
        shared.length > 0
          ? shared.length * folderHeight + threshold
          : defaultHeight;
    }

    const totalFoldersHeight = totalHeight - (personalHeight + sharedHeight);
    globalHeight = totalFoldersHeight - 12;
  }

  return (
    <div
      className="ac--col ac--def__folder--cols"
      id="importDefinitionMain"
      data-test="ACDefinitionsFoldersList"
    >
      <ACDefinitionFolder
        title="Personal"
        folders={groupedData.personal}
        onLeafNodeClicked={onLeafNodeClicked}
        selectedFolder={selectedFolder}
        setselectedFolder={setselectedFolder}
        canAddNewFolders={canAddNewFolders}
        folderHeight={personalHeight}
      />
      <ACDefinitionFolder
        title="Shared"
        folders={groupedData.shared}
        onLeafNodeClicked={onLeafNodeClicked}
        selectedFolder={selectedFolder}
        setselectedFolder={setselectedFolder}
        folderHeight={sharedHeight}
      />
      <ACDefinitionFolder
        title="Global"
        folders={groupedData.global}
        onLeafNodeClicked={onLeafNodeClicked}
        selectedFolder={selectedFolder}
        folderHeight={globalHeight}
      />
    </div>
  );
};

ACDefinitionFoldersList.propTypes = {
  definitionList: PropTypes.shape({
    data: PropTypes.instanceOf(Array),
  }),
  onLeafNodeClicked: PropTypes.func,
  selectedFolder: PropTypes.shape({}),
  setselectedFolder: PropTypes.func,
  canAddNewFolders: PropTypes.bool,
};

export default ACDefinitionFoldersList;
